import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { useState } from "react";

/**
 * Used to send a put request to update an existing data record.
 * Sending the flag showSnackBar determines whether the function, would dispatch snackbars or not.
 */

const useSendPutRequest = (showSnackBar = false) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const updateData = (
    url,
    data,
    successMessage = null,
    errorMessage = null
  ) => {
    setIsLoading(true);
    return axiosInstance
      .put(url, data)
      .then((response) => {
        setIsLoading(false);
        setIsError(false);
        dispatch(
          setSnackbar({
            open: true,
            message: successMessage || "Request has been sent Successfully",
            error: false,
          })
        );

        return response;
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
        if (showSnackBar) {
          let errorMsg = errorMessage;
          const data = error?.response?.data;

          if (!errorMessage) {
            if (typeof data === "object" && (data?.details || data?.message)) {
              errorMsg = data.details || data.message;
            } else if (typeof data === "string") {
              errorMsg = data;
            } else {
              errorMsg = error?.message || "Internal Server Error.";
            }
          }

          dispatch(
            setSnackbar({
              open: true,
              message: errorMsg,
              error: true,
            })
          );
        }
        return null;
      });
  };

  return { requestMethod: updateData, isError, isLoading };
};

export default useSendPutRequest;
